import { useMemo } from 'react';
import { Box } from '@mui/material';
import { parseAnsiSequences, createColorPalette } from 'ansi-sequence-parser';

interface AnsiLogRowProps {
  children: string;
}

const colorPalette = createColorPalette({
  black: 'common.black',
  red: 'red.500',
  green: 'green.500',
  yellow: 'yellow.500',
  blue: 'blue.500',
  magenta: 'pink.500',
  cyan: 'cyan.500',
  white: 'grey.200',
  brightBlack: 'grey.800',
  brightRed: 'red.200',
  brightGreen: 'green.200',
  brightYellow: 'yellow.200',
  brightBlue: 'blue.200',
  brightMagenta: 'pink.200',
  brightCyan: 'cyan.200',
  brightWhite: 'common.white'
});

export const AnsiLogRow = ({ children }: AnsiLogRowProps) => {
  const tokens = useMemo(() => {
    try {
      return parseAnsiSequences(children);
    } catch {
      return [];
    }
  }, [children]);

  return (
    <>
      {tokens.map((token, index) => {
        const color = token.foreground ? colorPalette.value(token.foreground) : 'common.white';
        const backgroundColor = token.background ? colorPalette.value(token.background) : 'transparent';

        return (
          <Box component="span" key={`${token.value}-${index}`} sx={{ color, backgroundColor }}>
            {`${token.value}`}
          </Box>
        );
      })}
    </>
  );
};
